import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { Distribution } from 'src/app/models/distribution.model'
import { MainService } from 'src/app/services/main.service'

const perfIndex = 0
const distIndex = 1

@Injectable({
  providedIn: 'root',
})
export class DistributionsService {
  constructor(private readonly mainService: MainService) {}
  distributionModel = {} as Distribution

  getModelData(): Observable<Distribution> {
    return new Observable((subscriber) => {
      this.mainService
        .getDistributionObservable()
        .pipe(take(1))
        .subscribe((distObs) => {
          if (
            Object.keys(distObs).length !== 0 &&
            distObs[0] !== null &&
            distObs[0].name !== 'HTTPError'
          ) {
            this.distributionModel = {
              profile: distObs[perfIndex],
              distributions: distObs[distIndex],
            }
          }
          subscriber.next(this.distributionModel)
          subscriber.complete()
        })
    })
  }
}
